export class GetAllDistributionSystems {
  static readonly type = '[distributionSystems] Get All';
  constructor() {}
}
